import {
  AuthType,
  CloudToolsError,
  MutedScanError,
  Region,
  Schedule,
} from '../entities';
import { AccountUser } from './accountUser';

export enum CloudAccountType {
  AWS = 'AWS',
  AZURE = 'Azure',
}

export interface Account {
  AccountId: string;
  AccountName: string;
  Title: string;
  Type: CloudAccountType;
  Description: string;
  BackstageOwner: string;
  Project: string;
  Labels: { key: string; value: string }[];
  Errors: CloudToolsError[];
  MutedErrors?: MutedScanError[];
  Regions: Region[];
  ReportFormatVersion: number;
  InventoryFormatVersion: number;
  CatalogFormatVersion: number;
  LastScanTime?: string;
  LastSyncTime?: string;
  AuthType?: AuthType;
  ScanSchedule?: Schedule;
  Users?: AccountUser[];
  /** Set by the backend on every update; never sent by clients. */
  UpdatedAt?: string;
  /** Transport-only optimistic-locking echo; the backend strips it. */
  ExpectedUpdatedAt?: string;
}
